export const CONSTANT = {
  encodingType: [
    {
      label: 'UTF-8',
      value: 'UTF-8',
    },
    {
      label: 'WINDOWS-874',
      value: 'WINDOWS-874'
    }
  ]
};

export const SUPPORT_FORMAT = ['application/pdf'];

export const ITEMS_PER_PAGE_OPTIONS = [
  { label: '10', value: 10 },
  { label: '40', value: 40 },
  { label: '100', value: 100 }
];

export const PAGINATION = {
  MAX_SIZE: 10,
  PAGE_SIZE: 40
};

export const DOC_TEMPLATES = [
  {
    name: 'ใบกำกับภาษี',
    nameEN: 'Tax Invoice',
    type: 'tax_invoice'
  },
  {
    name: 'ใบรับ',
    nameEN: 'Receipt',
    type: 'receipt'
  },
  {
    name: 'ใบลดหนี้',
    nameEN: 'Credit Note',
    type: 'credit_note'
  },
  {
    name: 'ใบเพิ่มหนี้',
    nameEN: 'Debit Note',
    type: 'debit_note'
  },
  {
    name: 'ใบส่งของ/ใบกำกับสินค้า',
    nameEN: 'Delivery Note',
    type: 'delivery_note'
  }
  // {
  //   name: 'ใบเสร็จรับเงิน/ใบกำกับภาษี',
  //   nameEN: 'Receipt/Tax Invoice',
  //   type: 'receipt_tax_invoice'
  // }
];
export  const HISTORY_ACTION = [
  {
    name: 'All',
    nameEN : ' ',
  },
  {
    name: 'สร้างข้อมูลภาษี',
    nameEN : '(Create tax data)',
  },
  {
    name: 'สร้างหรือแก้ไขบัญชีผู้ใช้',
    nameEN: '(Create or edit user)',
  },
  {
    name: 'ส่ง Email หรือ SMS',
    nameEN: '(Send E-mail or SMS)',
  },
  {
    name: 'ดาวน์โหลด PDF',
    nameEN: '(Download PDF)',
  },
  {
    name: 'ดาวน์โหลด XML',
    nameEN: '(Download XML)',
  },
  {
    name: 'แก้ไขปัญหา',
    nameEN: '(Resolve error)',
  },
  {
    name: 'เพิ่มรหัสลูกค้าหรือรหัสสาขา',
    nameEN: '(Add customer or delivery code)',
  },
  {
    name: 'อนุมัติ หรือ ปฏิเสธ คำร้องขอเอกสาร',
    nameEN: '(Approve or Reject document request)',
  },
  {
    name: 'เข้าสู่ระบบ',
    nameEN: '(Log in to the system)',
  },
  {
    name: 'อื่นๆ',
    nameEN: '(Others)',
  }

];

export const CALENDAR_LOCALE = {
  TH: {
    firstDayOfWeek: 0,
    dayNames: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'],
    dayNamesShort: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
    dayNamesMin: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
    monthNames: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
    monthNamesShort: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
    today: 'วันนี้',
    clear: 'ล้างข้อมูล'
  },
  EN: {
    firstDayOfWeek: 0,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun.', 'Mon.', 'Tue.', 'Wed.', 'Thu.', 'Fri.', 'Sat.'],
    dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'],
    today: 'Today',
    clear: 'Clear'
  }
};

export const COMPANY_TEMPLATES = [
  {
    name: 'Benning Comapny',
    type: 'Benning_Comapny'
  },
  {
    name: 'Admin Company',
    type: 'Admin Company'
  },
  {
    name: 'Sunrise Company',
    type: 'Sunrise Company'
  },
  {
    name: 'Facebook Company co',
    type: 'Facebook Company co'
  },
];


export const MODAL_CONFIG = {
  animated: true,
  class: 'modal-dialog-centered'
};




// WEBPACK FOOTER //
// /opt/app/src/app/services/constant.ts